import { NavLink, Link } from 'react-router-dom';

const LINKS = [
  { to: '/how-it-works', label: 'how it works' },
  { to: '/hall-of-fame', label: 'hall of fame' },
  { to: '/about', label: 'about' },
];

export default function Nav() {
  return (
    <nav
      className="pad-x"
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '18px 40px',
        borderBottom: '1px solid var(--border)',
        position: 'sticky',
        top: 0,
        zIndex: 100,
        background: 'rgba(15,15,15,0.97)',
        backdropFilter: 'blur(8px)',
      }}
    >
      <Link
        to="/"
        style={{
          fontSize: 17,
          fontWeight: 500,
          color: 'var(--fg)',
          letterSpacing: '-0.01em',
          textDecoration: 'none',
        }}
      >
        ImNotGoing
      </Link>
      <div
        className="nav-links"
        style={{ display: 'flex', gap: 36, alignItems: 'center' }}
      >
        {LINKS.map((link) => (
          <NavLink
            key={link.to}
            to={link.to}
            style={({ isActive }) => ({
              fontSize: 14,
              fontWeight: isActive ? 600 : 400,
              color: isActive ? 'var(--fg)' : 'var(--fg-muted)',
              letterSpacing: '0.01em',
              transition: 'color 0.15s',
              textDecoration: 'none',
            })}
          >
            {link.label}
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
